module.exports = __webpack_public_path__ + "img/tab2.bfa5a2a9.png";